import BaseService from './base.service';
import { isObj, isNonEmptyStr } from '@/utils';


const baseUrl = process.env.VUE_APP_NEW_API_BASE_URL || 'http://localhost:8989/';
const prefix = process.env.VUE_APP_NEW_API_PREFIX || '/v4';

export default {
  async getLocationCountryCode(ip) {
    try{
      const params = ip ? { ip } : null;
      const response = await BaseService.api().get('/country', { baseURL: baseUrl + prefix, params });
      // if call not failed but not received data
      const { data } = response;
      return isObj(data) && isNonEmptyStr(data.geoplugin_countryCode) ? data.geoplugin_countryCode : 'US';
    } catch {
      return 'US';
    }
  }
};
